import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrintAssetsQRRoutingModule } from './print-assets-qr-routing.module';
import { PrintAssetLinkComponent } from './print-asset-link/print-asset-link.component';
import { PrintAssestLandingPageComponent } from './print-assest-landing-page/print-assest-landing-page.component';
import { PrintAssestQRDetailsComponent } from './print-assest-qr-details/print-assest-qr-details.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';


@NgModule({
  declarations: [
    PrintAssetLinkComponent,
    PrintAssestLandingPageComponent,
    PrintAssestQRDetailsComponent
  ],
  imports: [
    CommonModule,
    PrintAssetsQRRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class PrintAssetsQRModule { }
